import { ChevronDown, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Field, fieldInputCls } from "@/components/Field";

export const MultiPick = ({ label, options, value, onChange, allLabel, countLabel, testid, required }) => {
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  const names = options.filter(([id]) => value.includes(id)).map(([, n]) => n);
  const text = !names.length ? allLabel : names.length === 1 ? names[0] : `${names.length} ${countLabel}`;
  return (
    <Field label={label}>
      <Popover>
        <PopoverTrigger asChild>
          <button type="button" data-testid={testid} className={`${fieldInputCls} w-full flex items-center justify-between gap-2 px-3 text-left ${required && !value.length ? "border-[#FFB800] text-[#FFB800]" : ""}`}>
            <span className="truncate">{text}</span><ChevronDown className="w-4 h-4 opacity-50 shrink-0" />
          </button>
        </PopoverTrigger>
        <PopoverContent align="start" className="w-[340px] p-1 bg-[#12141C] border-[#282D3D] max-h-[340px] overflow-y-auto">
          {value.length > 0 && (
            <button type="button" data-testid={`${testid}-clear`} onClick={() => onChange([])} className="w-full flex items-center gap-2 px-2 py-1.5 font-mono text-[11px] uppercase text-[#FFB800] hover:bg-[#181B26] rounded-sm">
              <X className="w-3.5 h-3.5" /> {allLabel}
            </button>
          )}
          {options.map(([id, name, n]) => (
            <label key={id} data-testid={`${testid}-option-${id}`} className="flex items-center gap-2 px-2 py-1.5 rounded-sm hover:bg-[#181B26] cursor-pointer text-sm">
              <Checkbox checked={value.includes(id)} onCheckedChange={() => toggle(id)} />
              <span className="truncate flex-1">{name}</span>{n != null && <span className="font-mono text-[10px] text-slate-500">{n}</span>}
            </label>
          ))}
        </PopoverContent>
      </Popover>
    </Field>
  );
};
